import {
  SET_SUPPORT_FORM_VALUE,
  RESET_SUPPORT_FORM_VALUE,
} from "constants-lib/actionTypes"

/**
 * Creates an action to set a value in the support form state.
 * @param {string} key - The key in the support form state to update.
 * @param {*} value - The new value for the specified key.
 * @returns {Object} An action object with type SET_SUPPORT_FORM_VALUE and a payload containing the key and value.
 */
export const setSupportFormValue = (key, value) => ({
  type: SET_SUPPORT_FORM_VALUE,
  payload: {
    key,
    value,
  },
})

export const resetSupportFormValue = () => ({
  type: RESET_SUPPORT_FORM_VALUE,
})
